import { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import ListagemDeMunicipios from "../Municipios";
import BarraDeNavegacao from "../../componentes/BarraDeNavegacao";
import "./styles.scss";
import ListagemDeLocaisAtendimento from "../LocaisAtendimento";
import ListagemProjetos from "../Projetos";

const GerenciarLocaisEPermissoes = () => {
  const [abaAtiva, setAbaAtiva] = useState<
    "locais" | "projetos" | "municipios"
  >("locais");

  const location = useLocation();

  useEffect(() => {
    const parametros = new URLSearchParams(location.search);
    const aba = parametros.get("aba");

    if (aba === "locais" || aba === "projetos" || aba === "municipios") 
      setAbaAtiva(aba);
    else setAbaAtiva("locais");
    
  }, [location.search]);

  return (
    <>
      <BarraDeNavegacao
        titulo="Gerenciar locais e permissões"
        comBotaoADireita={false}
      />

      <div className="tabs-cadastro__menu1">
        <button
          className={abaAtiva === "locais" ? "ativo" : ""}
          onClick={() => setAbaAtiva("locais")}
        >
          Locais de atendimento
        </button>
        <button
          className={abaAtiva === "projetos" ? "ativo" : ""}
          onClick={() => setAbaAtiva("projetos")}
        >
          Projetos
        </button>

        <button
          className={abaAtiva === "municipios" ? "ativo" : ""}
          onClick={() => setAbaAtiva("municipios")}
        >
          Municípios
        </button>
      </div>

      <div className="tabs-cadastro__conteudo1">
        {abaAtiva === "locais" && <ListagemDeLocaisAtendimento />}
        {abaAtiva === "projetos" && <ListagemProjetos />}
        {abaAtiva === "municipios" && <ListagemDeMunicipios />}
      </div>
    </>
  );
};

export default GerenciarLocaisEPermissoes;
